<style lang="less" scoped>
	.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
	// height: 100%;
	// .layout-1{
	// 	height: 100%;
	// }
}
.layout-logo{
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
}
.layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.layout-footer-center{
    text-align: center;
}
.ivu-layout-content{
	
}
</style>
<template>
	<div class="layout">
		<Layout class="layout-1">
			<Header v-show="quanp">
				<Menu mode="horizontal" class="header" theme="dark" active-name="1">
					<div class="layout-logo" title="机器人便利店">
						<!-- <img class="logo" src="../../static/img/1.png" /> -->
					</div>
					<div class="grxx">

						<MenuItem name="1">
						<p @click="getEmp()" title="点击修改个人信息">
							<Icon type="ios-body" />
							欢迎你，{{user.empName}}
						</p>
						</MenuItem>
						<MenuItem name="1">
						<p @click="exit()">退出</p>
						</MenuItem>
					</div>
					<Modal v-model="modal4" title="个人信息" cancel-text="" ok-text="关闭">
						<Form ref="emp" :model="emp" :label-width="80">
							<FormItem label="姓名" class="sj">
								<Input v-model="emp.name" placeholder="请输入姓名"></Input>
							</FormItem>
							<FormItem label="地址" class="sj">
								<Input v-model="emp.address" placeholder="请输入地址"></Input>
							</FormItem>
							<FormItem label="联系方式" class="sj">
								<Input v-model="emp.phone" placeholder="请输入联系方式"></Input>
							</FormItem>
							<FormItem label="密码" class="sj">
								<Input v-model="emp.password" type="password" placeholder="请输入联系方式"></Input>
							</FormItem>
							<FormItem label="确认密码" class="sj">
								<Input v-model="emp.password1" type="password" placeholder="请输入联系方式"></Input>
							</FormItem>
							<FormItem>
								<Button type="primary" @click="updateEmp()">提交</Button>
							</FormItem>
						</Form>

					</Modal>
				</Menu>
			</Header>
			<Layout>

				<Content :style="{minHeight: '280px', background: '#fff'}">
					<Layout>
						<Sider hide-trigger :style="{background: '#fff'}" v-show="quanp">

							<Menu active-name="1-2" theme="light" width="auto" accordion>
								<Submenu v-for="d in submenus" :name="d.name" :key="d.name">
									<template slot="title">
										<Icon :type="d.type"></Icon>
										<router-link :to="{name:d.url}" v-if="d.aaa=='1'">{{d.title}}</router-link>
										<span v-else>{{d.title}}</span>

									</template>
									<MenuItem v-for="item in d.items" :key="item.name" :name="item.name">
									<router-link :to="{name:item.url}">{{item.title}}</router-link>
									</MenuItem>

								</Submenu>

							</Menu>
						</Sider>
						<Content :style="{padding: '12px 24px 24px 24px', minHeight: minHeight, background: '#fff'}">

							<!-- <div @click="quanping" class="quanping">
									<Button type="error" ghost>{{quanpTitle}}</Button>
								</div> -->
								
							<Scroll :height="minHeight" >
									<router-view />
							</Scroll>
						</Content>
					</Layout>
				</Content>
			</Layout>
			<Footer class="layout-footer-center">&copy; 小捷智购（重庆）智能科技有限公司</Footer>
		</Layout>
	</div>

</template>
<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {

				modal4: false,
				emp: {
					address: '',
					name: '',
					phone: '',
					password: '1a2a3a4a5a6a7a',
					password1: '1a2a3a4a5a6a7a'
				},
				quanp: true,
				quanpTitle: '全屏',
				minHeight: "600px",
				minHeight1: "600px",
				user: {
					empName: '',
					type: ""
				},
				fullHeight: document.documentElement.clientHeight, //屏幕高度
				submenus: [],
				admin: [{ //jm管理员
					name: '101',
					type: 'logo-chrome',
					title: 'app版本管理',
					items: [{
						name: '101-1',
						url: 'jm/admin/appVersions/list1',
						title: 'app版本管理'
					}]
				}, { //人员管理
					name: '102',
					type: 'ios-keypad',
					title: '人员管理',
					items: [{
						name: '102-1',
						url: 'jm/admin/emp/list',
						title: '平台人员管理'
					}]
				}, { //公共数据管理
					name: '103',
					type: 'ios-keypad',
					title: '公共数据管理',
					items: [{
						name: '103-1',
						url: 'jm/admin/commonality/list',
						title: '数据管理'
					}, {
						name: '103-2',
						url: 'jm/admin/commonalityFile/list',
						title: '文件管理'
					}]
				}, { //权限管理
					name: '104',
					type: 'ios-keypad',
					title: '权限管理',
					items: [{
						name: '104-1',
						url: 'jm/admin/role/list',
						title: '角色管理'
					}, {
						name: '104-2',
						url: 'jm/admin/menu/list',
						title: '权限列表'
					}]
				}, {
					name: '106',
					type: 'ios-analytics-outline',
					title: '新闻咨询',
					items: [{
						name: '106-1',
						url: 'jm/admin/xinwenzixun/list',
						title: '新闻管理'
					}]
				}, {
					name: '107',
					type: 'ios-analytics-outline',
					title: '厂家管理',
					items: [{
						name: '107-1',
						url: 'jm/admin/manu/list',
						title: '厂家管理'
					}]
				}, {
					name: '108',
					type: 'ios-analytics-outline',
					title: '品牌',
					items: [{
						name: '108-1',
						url: 'jm/admin/brand/list',
						title: '品牌管理'
					}]
				}, {
					name: '109',
					type: 'ios-analytics-outline',
					title: '交互日志',
					items: [{
						name: '108-1',
						url: 'jm/admin/macMessageLog/list',
						title: '列表'
					}]
				}, {
					name: '110',
					type: 'ios-analytics-outline',
					title: '小程序扫码',
					items: [{
						name: '108-1',
						url: 'jm/admin/mac/list',
						title: '设备列表'
					}]
				}, {
					name: '111',
					type: 'ios-analytics-outline',
					title: '接口访问时间',
					items: [{
						name: '111-1',
						url: 'jm/admin/responseTime/list',
						title: '接口访问时间'
					}, {
						name: '111-2',
						url: 'jm/admin/responseTime/list1',
						title: '接口信息'
					}]
				}, {
					name: '112',
					type: 'ios-analytics-outline',
					title: '用户意见',
					items: [{
						name: '112-1',
						url: 'jm/admin/clientOpinion/list',
						title: '用户意见'
					}]
				}, {
					name: '113',
					type: 'ios-analytics-outline',
					title: '加盟信息',
					items: [{
						name: '111-1',
						url: 'jm/admin/join/list',
						title: '加盟信息'
					}]
				}, {
					name: '114',
					type: 'ios-analytics-outline',
					title: '工控机mac',
					items: [{
						name: '114-1',
						url: 'jm/admin/uuid/list',
						title: 'mac地址'
					}]
				}],
				//新媒体
				xinmeiti: [{
					name: '100',
					type: 'ios-home-outline',
					title: '首页',
					url: 'fac',
					aaa: '1',
					items: []
				}, {
					name: '202',
					type: 'ios-easel-outline',
					title: '新闻资讯',
					items: [{
						name: '202-0',
						url: 'jm/admin/xinwenzixun/list',
						title: '新闻资讯'
					}, ]
				}],
				//安卓开发人员
				android: [{
					name: '100',
					type: 'ios-home-outline',
					title: '首页',
					url: 'fac',
					aaa: '1',
					items: []
				}, {
					name: '202',
					type: 'ios-easel-outline',
					title: '设备日志',
					items: [{
						name: '202-0',
						url: 'jm/android/maclog/list',
						title: '设备日志'
					}, ]
				}, {
					name: '203',
					type: 'ios-easel-outline',
					title: '唯一标识',
					items: [{
						name: '203-0',
						url: 'jm/android/uuid/list',
						title: '设备唯一标识'
					}, ]
				}, {
					name: '204',
					type: 'ios-easel-outline',
					title: '日志文件',
					items: [{
						name: '204-0',
						url: 'jm/android/filelog/list',
						title: '设备日志文件'
					}, ]
				}, {
					name: '205',
					type: 'ios-easel-outline',
					title: 'app版本管理',
					items: [{
						name: '205-0',
						url: 'jm/android/appVersions/list1',
						title: 'app版本管理'
					}, ]
				}],
				finance: [{ //jm财务
					name: '801',
					type: 'md-contacts',
					title: '运营分成',
					items: [{
						name: '801-1',
						url: 'jm/finance/type/list',
						title: '商品'
					}]
				}, { //jm财务
					name: '802',
					type: 'md-calculator',
					title: '对账',
					items: [{
							name: '802-1',
							url: 'jm/finance/checking/oper',
							title: '运营商'
						}, {
							name: '802-2',
							//url: 'jm/finance/checking/alliance',
							url: "jm/platform/finance/alliance/earnings",
							title: '加盟商'
						},
						{
							name: '802-3',
							url: 'jm/finance/checking/biaobiaoMonth',
							title: '每月报表'
						},
					]
				}],
				macProduction: [{ //jm工厂
					name: '101',
					type: 'md-construct',
					title: '基础数据管理',
					items: [{
							name: '101-1',
							url: 'jm/mac/mactype/list',
							title: '设备类型管理'
						},
						{
							name: '101-2',
							url: 'jm/mac/machine/list',
							title: '设备信息管理'
						},
						{
							name: '101-4',
							url: 'jm/mac/faultType/list',
							title: '故障类型管理'
						}
					]
				}],
				facility: [{ //jm区域设备管理人员
					name: '101',
					type: 'md-copy',
					title: '合同管理',
					items: [{
						name: '101-1',
						url: 'jm/facility/macOrder/list',
						title: '合同信息'
					}]
				}],
				platform: [ //jm平台区域管理人员
					{
						name: '200',
						type: 'ios-home',
						url: 'jmPlatformShangpingtongjiHome',
						title: '首页',
						aaa: '1',
						items: []
					},
					{
						name: '230',
						type: 'md-build',
						url: 'jm/platform/mac/list',
						title: '设备信息',
						aaa: '1',
						items: []
					},
					{
						name: '201',
						type: 'ios-body',
						title: '平台用户管理',
						items: [{
							name: '201-1',
							url: 'jm/platform/alliance/list',
							title: '加盟商管理'
						}, {
							name: '201-2',
							url: 'jm/platform/oper/list',
							title: '运营商管理'
						},
						// {
						// 	name: '201-3',
						// 	url: 'jm/platform/adv/list',
						// 	title: '广告人员管理'
						// },
						{
							name: '201-4',
							url: 'jm/platform/fac/list',
							title: '设备管理人员管理'
						}, {
							name: '201-7',
							url: 'jm/platform/waimai/list',
							title: '配送人员管理'
						}, {
							name: '201-5',
							url: 'jm/platform/plat/list',
							title: '下级平台人员管理'
						}, {
							name: '201-6',
							url: 'jm/platform/client/list',
							title: '用户管理'
						}]
					}, {
						name: '202',
						type: 'md-book',
						title: '订单管理',
						items: [{
								name: '201-1',
								url: 'jm/platform/macOrder/list',
								title: '加盟商订单'
							}, {
								name: '202-1',
								url: 'jm/platform/macAisleOrder/list',
								title: '供应商订单'
							}
							// ,{
							// 	name: '203-1',
							// 	url: 'jm/platform/macAisleOrder/list',
							// 	title: '广告投放订单'
							// }
						]
					},
					{
						name: '203',
						type: 'ios-browsers',
						title: '报表信息',
						items: [
							// {
							// 	name: '203-3',
							// 	url: 'jm/platform/finance/advList',
							// 	title: '加盟商广告分成报表'
							// },
							{
								name: '203-2',
								url: 'jm/platform/finance/alliance/earnings',
								title: '加盟商报表'
							},
							{
								name: '203-4',
								url: 'jm/platform/finance/oper/earnings',
								title: '供应商报表'
							},
							
							// {
							// 	name: '203-5',
							// 	url: 'jm/finance/refund/list',
							// 	title: '小捷退款'
							// },
							
							{
								name: '203-6',
								url: 'jm/platform/coupon/list',
								title: '优惠券管理'
							}
						]
					}
				],
				alliance: [ //加盟商
					{
						name: '300',
						type: 'ios-home',
						url: 'alliancetj1',
						title: '首页',
						aaa: '1',
						items: []
					},
					{
						name: '301',
						type: 'md-construct',
						title: '设备信息',
						items: [{
							name: '301-1',
							url: 'alliance/mac/list',
							title: '设备管理'
						}]
					}, {
						name: '302',
						type: 'ios-calendar',
						title: '报表信息',
						items: [{
								name: '302-1',
								url: 'alliance/finance/list/mac',
								title: '商品报表'
							},{
								name: '302-6',
								url: 'alliance/baobiao/list/day',
								title: '每日报表'
							},
							{
								name: '302-7',
								url: 'alliance/baobiao/list/month',
								title: '月报表'
							},{
								name: '302-8',
								url: 'alliance/baobiao/list/year',
								title: '年报表'
							},{
								name: '302-9',
								url: 'alliance/baobiao/list/hj',
								title: '总报表'
							}
							
						]
					}, {
						name: '303',
						type: 'md-clipboard',
						title: '我的订单',
						items: [{
							name: '303-1',
							url: 'alliance/mac/order/list',
							title: '设备订单'
						}]
					}
				],
				oper: [ //供应链
					{
						name: '400',
						type: 'ios-home',
						url: 'opertj1',
						title: '首页',
						aaa: '1',
						items: []
					},
					{
						name: '401',
						type: 'ios-body',
						title: '层级管理',
						items: [{
							name: '401-1',
							url: 'oper/emp/list',
							title: '员工信息'
						},{
							name: '401-2',
							url: 'oper/district/list',
							title: '片区管理'
						}]
					}, {
						name: '402',
						type: 'md-construct',
						title: '设备管理',
						items: [{
							name: '402-1',
							url: 'oper/mac/list',
							title: '设备信息'
						}]
					}, {
						name: '404',
						type: 'ios-cafe',
						title: '商品管理',
						items: [{
								name: '404-1',
								url: 'oper/comm/type/list',
								title: '商品类别'
							},
							{
								name: '404-2',
								url: 'oper/comm/list',
								title: '商品详情'
							},
							{
								name: '404-3',
								url: 'jm/admin/brand/list',
								title: '品牌管理'
							},
							{
								name: '404-4',
								url: 'jm/admin/manu/list',
								title: '厂商管理'
							}
							// {
							// 	name: '404-3',
							// 	url: 'oper/repertory/list',
							// 	title: '商品出入库'
							// },
							// {
							// 	name: '404-3',
							// 	url: 'oper/mac/list',
							// 	title: '货道管理'
							// }

						]
					},
					{
						name: '405',
						type: 'ios-calendar',
						title: '报表管理',
						items: [{
							name: '405-1',
							url: 'oper/finance/list/mac',
							title: '订单信息'
						},{
							name: '405-6',
							url: 'oper/baobiao/list/day',
							title: '每日报表'
						},{
							name: '405-7',
							url: 'oper/baobiao/list/month',
							title: '月报表'
						},{
							name: '405-8',
							url: 'oper/baobiao/list/year',
							title: '年报表'
						},{
							name: '405-9',
							url: 'oper/baobiao/list/hj',
							title: '总报表'
						},
						{
							name: '405-2',
							url: 'oper/finance/tongji/list1',
							title: '商品统计'
						},{
							name: '405-5',
							url: 'oper/finance/tongji/list2',
							title: '商品类型统计'
						},{
					 		name: '405-10',
					 		url: 'oper/finance/daochu/exportsalesreport',
					 		title: '销售报表导出'
					 	}]
					}
				],
				oper1: [ //供应链
					{
						name: '400',
						type: 'ios-home',
						url: 'opertj1',
						title: '首页',
						aaa: '1',
						items: []
					},
					// {
					// 	name: '401',
					// 	type: 'ios-body',
					// 	title: '员工管理',
					// 	items: [{
					// 		name: '401-1',
					// 		url: 'oper/emp/list',
					// 		title: '员工信息'
					// 	}]
					// },
					{
						name: '402',
						type: 'md-construct',
						title: '设备管理',
						items: [{
							name: '402-1',
							url: 'oper/mac/list',
							title: '设备信息'
						}]
					}, {
						name: '404',
						type: 'ios-cafe',
						title: '商品管理',
						items: [{
								name: '404-1',
								url: 'oper/comm/type/list',
								title: '商品类别'
							},
							{
								name: '404-2',
								url: 'oper/comm/list',
								title: '商品详情'
							},
							// {
							// 	name: '404-3',
							// 	url: 'oper/repertory/list',
							// 	title: '商品出入库'
							// },
							// {
							// 	name: '404-3',
							// 	url: 'oper/mac/list',
							// 	title: '货道管理'
							// }
				
						]
					},
					 {
					 	name: '405',
					 	type: 'ios-calendar',
					 	title: '报表管理',
					 	items: [{
					 		name: '405-1',
					 		url: 'oper/finance/list/mac',
					 		title: '订单信息'
					 	},{
					 		name: '405-6',
					 		url: 'oper/baobiao/list/day',
					 		title: '每日报表'
					 	},{
					 		name: '405-7',
					 		url: 'oper/baobiao/list/month',
					 		title: '月报表'
					 	},{
					 		name: '405-8',
					 		url: 'oper/baobiao/list/year',
					 		title: '年报表'
					 	},{
					 		name: '405-9',
					 		url: 'oper/baobiao/list/hj',
					 		title: '总报表'
					 	},
					 	{
					 		name: '405-2',
					 		url: 'oper/finance/tongji/list1',
					 		title: '商品统计'
					 	},{
					 		name: '405-5',
					 		url: 'oper/finance/tongji/list2',
					 		title: '商品类型统计'
					 	}
						]
					 }
					// {
					// 	name: '405',
					// 	type: 'ios-calendar',
					// 	title: '报表管理',
					// 	items: [{
					// 		name: '405-1',
					// 		url: 'oper/finance/list/mac',
					// 		title: '报表信息'
					// 	}]
					// }
				],
				adv: [{
					name: '500',
					type: 'ios-home',
					url: 'jmAdvguanggaotongjiHome',
					title: '首页',
					items: []
				}, { //jm广告管理者
					name: '501',
					type: 'ios-keypad',
					title: '投放商管理',
					items: [{
						name: '501-1',
						url: 'jm/adv/sponsor/list',
						title: '投放商信息'
					}]
				}, { //广告素材管理
					name: '502',
					type: 'ios-keypad',
					title: '广告素材管理',
					items: [{
						name: '502-1',
						url: 'jm/adv/sponsor/list',
						title: '广告素材信息'
					}]
				}, { //广告订单管理
					name: '503',
					type: 'ios-keypad',
					title: '广告订单管理',
					items: [{
						name: '503-1',
						url: 'jm/adv/order/list',
						title: '广告订单信息'
					}]
				}]

			}
		},
		methods: {
			exit() { //退出登陆
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/login/out',
					data: _this.emp,
					_this: _this,
					success: function(data) {
						console.log(data)
						sessionStorage.clear();

					}
				})

				_this.$Message.warning('退出成功');
				_this.$router.push('/login')
			},
			quanping() {
				let _this = this
				if (_this.quanp) {
					_this.quanp = false
					_this.quanpTitle = '取消全屏'

				} else {
					_this.quanp = true
					_this.quanpTitle = '全屏'
				}
			},
			getEmp() {
				let _this = this
				_this.modal4 = true
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/plat/emp/get',
					data: {},
					_this: _this,
					success: function(data) {
						_this.emp.name = data.emp.name
						_this.emp.address = data.emp.address
						_this.emp.phone = data.emp.phone
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			},
			updateEmp() {
				let _this = this
				if (_this.emp.name == "" || _this.emp.phone == "" || _this.emp.address == "" || _this.emp.password == "") {
					_this.$Message.error('请完善信息后再提交!');
					return;
				}
				if (_this.emp.password != _this.emp.password1) {
					_this.$Message.error('两次输入的密码不一致请重新输入!');
					return;
				}
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/plat/emp/update',
					data: _this.emp,
					_this: _this,
					success: function(data) {
						_this.user.empName = _this.emp.name
						_this.$Message.success('修改成功!');
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			}
		},
		created() {
			document.title = '小捷智购管理平台'
			var hegiht = document.documentElement.clientHeight- 171
			this.minHeight = hegiht
			this.minHeight1 = hegiht+'px'
			let u = sessionStorage.getItem("user")

			if (u) {
				this.user = JSON.parse(u)
				switch (this.user.type) {
					case '1': //设备生产者
						this.submenus = this.macProduction
						break;
					case '2': //jm平台管理人员
						this.submenus = this.platform
					//	this.$router.push('/jmPlatformShangpingtongjiHome')
						break;
					case '3': //jm加盟商管理人员
						this.submenus = this.alliance
						//this.$router.push('/alliancetj1')
						break;
					case '4': //供应链管理人员
						this.submenus = this.oper
						//this.$router.push('/opertj1')
						break;
					case '5': //供应链员工
						this.submenus = this.oper1
						//this.$router.push('/opertj1')
						break;
					case '6': //广告管理员
						this.submenus = this.adv
						//this.$router.push('/jmAdvguanggaotongjiHome')
						break;
					case '7': //设备管理人员
						this.submenus = this.facility
						break;
					case '9': //系统管理员
						this.submenus = this.admin
						break;
					case '10': //财务
						this.submenus = this.finance
						break;

					case '11': //系统管理员
						this.submenus = this.android
						break;
					case '12': //系统管理员
						this.submenus = this.xinmeiti
						break;
					default:
						this.$router.push('/login')
						break;
				}
			} else {
				this.$router.push('/login')
			}

		},
		//监听屏幕变化
		mounted () {
		 const that = this
		 window.onresize = () => {
			 return (() => {
				var hegiht = document.documentElement.clientHeight- 171
				this.minHeight = hegiht
				this.minHeight1 = hegiht+'px'
			 })()
		 }
		}

	}
</script>
<style scoped="scoped">
	.header {
		display: flex;
		justify-content: space-between;
	}

	a {
		color: #515a6e;
	}

	.router-link-active {
		color: #007AFF;
	}

	.ivu-menu-submenu-title i {
		font-size: 22px;
	}

	.ivu-menu-vertical {
		min-height: 100%;
	}

	.quanping {
		display: flex;
		justify-content: flex-end;
	}

	.grxx {
		font-weight: 700;
	}

	.ivu-menu-dark {
		background-color: #007AFF !important;
	}

	.ivu-layout-header {
		background-color: #007AFF !important;
	}

	.layout-logo {
		background-color: #007AFF !important;
		top: 0px;
	}

	.logo {
		width: 60px !important;
		height: 60px !important;
	}

	.ivu-menu-light {
		background-color: #F5F7F9;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/main.vue